<template>
  <div class="modal-card" style="width: auto">
    <div class="modal-card-head">
      <span class="title is-3 has-text-black">{{
        $t("welcomeJomatik.welcomeToMurtfeldtAS")
      }}</span>
    </div>
    <div class="modal-card-body">
      <div class="container is-max-desktop">
        <p class="is-size-4">
          {{ $t("welcomeJomatik.dearJomatikCustomer") }}<br />
        </p>
        <p class="is-size-4" v-html="$t('welcomeJomatik.happyToSeeYou')"></p>
        <div
          class="
            p-3
            my-6
            is-flex
            is-flex-wrap-wrap
            is-align-items-center
            is-justify-content-space-between
            company-transition
          "
          style="border: 1px solid black"
        >
          <figure class="image">
            <img
              src="@/assets/img/jomatik_logo.jpg"
              title="Jomatik"
              alt="Jomatik Logo"
            />
          </figure>
          <span class="is-size-3-desktop">{{
            $t("welcomeJomatik.nameChange")
          }}</span>
          <figure class="image">
            <img
              src="@/assets/img/logo.png"
              title="Murtfeldt Additive Solutions"
              alt="Murtfeldt Additive Solutions Logo"
            />
          </figure>
        </div>
        <div class="my-6">
          <p class="is-size-3">
            {{ $t("welcomeJomatik.everythingAsNormal") }}
          </p>
          <ul class="is-size-4">
            <li>- {{ $t("welcomeJomatik.sameTeam") }}</li>
            <li>- {{ $t("welcomeJomatik.sameService") }}</li>
            <li>- {{ $t("welcomeJomatik.sameLogin") }}</li>
          </ul>
        </div>
        <div class="my-6">
          <p
            class="is-size-4"
            v-html="$t('welcomeJomatik.marketPlaceNote')"
          ></p>
        </div>
        <div class="is-size-4">
          <p
            v-html="
              $t('welcomeJomatik.discount', { amount: 10, code: 'welcome_MAS' })
            "
          ></p>
          <br />
          <br />
        </div>
        <p class="is-size-4" v-html="$t('welcomeJomatik.thankYou')"></p>
      </div>
    </div>
    <div class="modal-card-foot is-justify-content-end">
      <a
        class="button is-rounded is-info"
        href="https://3d-print.jomatik.de/shop.php"
        target="_blank"
      >
        {{ $t("welcomeJomatik.goToMarketPlace") }}
      </a>
      <button class="button is-rounded is-primary-dark" @click="close()">
        {{ $t("welcomeJomatik.goToStart") }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "WelcomeJomatik",
  methods: {
    close() {
      this.$router.push(this.$route.fullPath.replace(this.$route.hash, ""));
      this.$parent.close();
    },
  },
};
</script>

<style scoped lang="scss">
.company-transition {
  .image {
    width: 100%;
    margin: 1rem 0;
  }

  span {
    display: block;
    text-align: center;
    width: 100%;
  }
}

@media screen and (min-width: $tablet) {
  .company-transition {
    .image {
      margin: 0;
      width: 33%;
    }

    span {
      display: inline;
      width: auto;
    }
  }
}
</style>